module.exports = __webpack_public_path__ + "img/main-background.555dcac6.jpeg";